export default {
    setTenant (state, tenant) {
        state.tenant = tenant
    },

    setCurrentSubscription (state, subscription) {
        state.tenant.current_subscription = subscription
    },

    setPrices (state, prices) {
        state.yearlyPrice = prices.yearly
        state.monthlyPrice = prices.monthly
        state.totalYearlyPrice = prices.total_yearly
        state.totalMonthlyPrice = prices.total_monthly
    },

    populateUsers (state, users) {
        state.users = users
    },

    populateInvoices (state, invoices) {
        state.invoices = invoices
    },

    addUsers (state, users) {
        state.users = state.users.concat(users)
    },

    removeUser (state, userId) {
        state.users = state.users.filter(user => user.id !== userId)
    },

    updateUser (state, updatedUser) {
        const index = state.users.findIndex(user => user.id === updatedUser.id)

        state.users.splice(index, 1, updatedUser)
    }
}
